import { Box } from '@mui/material';
import AllTables from './allTables';

const ReportTable = ({
  data,
  dayBookData,
  setDayBookData,
  showSearch,
  selectedTab,
  ledgersData,
  setTableData,
  includeOpeningBalance,
  page,
  dataCount,
  setdataCount,
  gstData,
  setPage,
  selectedAccount,
  listOfStates,
  rowsPerPage,
  setRowsPerPage,
  dayBookList,
  handleChangePage,
}) => {
  const flattenedArray1 = data?.flat();
  console.log(data, 'ttttttttttttttt');

  const isPresent = selectedAccount?.some((item2) => flattenedArray1?.some((item1) => item1.accountid === item2.accountsid));
  return (
    <Box sx={{ width: '100%' }} className="custom-scrollbar">
      {data && data.length > 0 && isPresent ? (
        data.map((dat, i) => (
          <AllTables
            key={dat.accountid}
            data={dat}
            includeOpeningBalance={includeOpeningBalance}
            setTableData={setTableData}
            setdataCount={setdataCount}
            ledgersData={ledgersData}
            rowsPerPage={rowsPerPage}
            handleChangePage={handleChangePage}
          />
        ))
      ) : dayBookData && dayBookData.length >= 0 ? (
        <AllTables
          dayBookData={dayBookData}
          selectedTab={selectedTab}
          setRowsPerPage={setRowsPerPage}
          setTableData={setDayBookData}
          rowsPerPage={rowsPerPage}
          showSearch={showSearch}
          dataCount={dataCount}
          setdataCount={setdataCount}
          page={page}
          setPage={setPage}
          dayBookList={dayBookList}
          handleChangePage={handleChangePage}
        />
      ) : (
        gstData &&
        gstData.length > 0 &&
        gstData[0]?.label !== 'No data' && <AllTables gstData={gstData} listOfStates={listOfStates} selectedAccount={selectedAccount} />
      )}
    </Box>
  );
};

export default ReportTable;
